<template lang="html">
  <div class="card">
    <div class="card-thumbnail"
      :style="`background-image: url(/api/files/${image})`"
      >
    </div>
    <div class="card-content">

      <h4 class="card-title">
        {{title}}
      </h4>
      <h5 class="card-subtitle">
        {{artist}}
      </h5>
      <p class="card-description">
        {{description}}
      </p>
    </div>
    <div class="card-footer">
      <div class="card-actions">
        <router-link :to="`/artworks/${id}`"
          class="button button-primary">
          See
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "image",
    "title",
    "artist",
    "description",
    "id"
    ]
}
</script>

<style lang="scss" scoped>

// $primary-color:red;

.card {
  display: inline-block;
  position: relative;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  border-radius: 5px;
  background: white;
  width: calc(960px/3 - 2em);
  margin: 0 2em 2em 0;
  height: 470px;
  flex: 0 0 auto;


  // @include media-query($on-palm) {
  //   width: 100%;
  //   margin: 0;
  //   margin-bottom: 1.5em;
  // }

  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
    transition: .5s;
    -webkit-transform: scale(1.05);
    -moz-transform: scale(1.05);
    transform: scale(1.05);
    .card-thumbnail {
      opacity: .6;
    }
  }

  .card-thumbnail {
      background: white;
      height: 250px;
      overflow: hidden;
      // background-size: cover;
      background-position: center;

      .card-date {
        position: absolute;
        top: 20px;
        right: 20px;
        z-index: 1;
        // background: $primary-color;
        color: white;
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        // @include radius(50%);
        font-weight: 700;
        .day {
          font-size: 18px;
        }
        .month {
          font-size: 12px;
          text-transform: uppercase;
        }
      }
    }

  .card-footer {
    text-align: right;
    padding: 10px 30px 0 30px;
    // border-top: 1px solid $primary-color;
    // background-color: $other-color;
  }

  .card-content {

    padding: 30px 30px 0 30px;

    .card-category {
      padding: 10px 15px;
      font-size: 14px;
      font-weight: 600;
      text-transform: uppercase;
    }

    .card-title {
      margin: 0;
      padding: 0 0 10px;
      font-size: 26px;
      font-weight: 700;
    }
    .card-subtitle {
      margin: 0;
      padding: 0 0 20px;
      font-size: 20px;
      font-weight: 400;
    }

    .card-description {
      display: none;
      font-size: 14px;
      line-height: 1.8em;
    }

  }

}
</style>
